import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { LegacyTeacherFeedbackService } from '../teacher-feedback-service/legacy-teacher-feedback.service';
import { TeacherFeedbackDto } from '../teacher-feedback-service/teacher-feedback-dto';
import { TeacherFeedbackResponseStatus } from '../teacher-feedback-response-status/teacher-feedback-response-status';
import { LiveClassFeedbacksService } from '../../shared/live-class-feedbacks/live-class-feedbacks.service';
import { finalize } from 'rxjs/operators';
import { FeedbackResponseDTO } from '../teacher-feedback-service/private-class-feedback-dto';
import { TeacherFeedbackType } from '../teacher-feedback-service/teacher-feedback-type';
import { formatTeacherResponseText } from '../../shared/utils/text-utils';

@Component({
  selector: 'lp2-teacher-feedback-snippet',
  templateUrl: './teacher-feedback-snippet.component.html',
  styleUrls: ['./teacher-feedback-snippet.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TeacherFeedbackSnippetComponent implements OnInit {
  @Input() feedback: TeacherFeedbackDto;

  public date: number;
  public isLoading = false;
  public status: TeacherFeedbackResponseStatus;
  public title: string;
  public TeacherFeedbackResponseStatus = TeacherFeedbackResponseStatus;

  constructor(
    private teacherFeedbackService: LegacyTeacherFeedbackService,
    private liveClassFeedbacksService: LiveClassFeedbacksService
  ) {}

  ngOnInit(): void {
    if (!this.feedback) {
      return;
    }
    this.date = this.feedback.response ? this.feedback.response.date : this.feedback.date;
    this.status = this.getStatus();
    this.getFeedbackResponse$().subscribe((feedbackResponse) => {
      if (this.feedback.requestType === TeacherFeedbackType.ASK_A_TEACHER) {
        this.feedback.response.text = formatTeacherResponseText(this.feedback.response.text);
      }

      this.setTitle(feedbackResponse);
    });
  }

  private getStatus() {
    return this.teacherFeedbackService.getFeedbackStatus(this.feedback);
  }

  private getFeedbackResponse$() {
    if (!this.feedback.response) {
      return;
    }

    this.isLoading = true;
    return this.liveClassFeedbacksService
      .getLiveClassFeedbackById(this.feedback.response.id)
      .pipe(finalize(() => (this.isLoading = false)));
  }

  private setTitle(feedbackResponse: FeedbackResponseDTO) {
    if (this.feedback.requestType !== TeacherFeedbackType.LIVE_CLASS_FEEDBACK) {
      this.title = this.feedback.requestType;
      return;
    }

    if (feedbackResponse && feedbackResponse.lessonName) {
      this.title = feedbackResponse.lessonName;
    } else {
      this.title = this.feedback.text;
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/teacher-feedback-snippet/teacher-feedback-snippet.component.ts